<script setup lang="ts">
import { computed } from 'vue'
import type { Component } from 'vue'

const props = defineProps<{
    modelValue: boolean
    width?: string | number
    title?: string
    component?: Component | null
    componentProps?: Record<string, unknown>
}>()

const emit = defineEmits<{
    (e: 'update:modelValue', value: boolean): void
    (e: 'close'): void
    (e: 'result', value: unknown): void
}>()

const visible = computed({
    get: () => props.modelValue,
    set: (value: boolean) => {
        emit('update:modelValue', value)
        if (!value) emit('close')
    },
})

const close = () => {
    visible.value = false
}

const finish = (result: unknown) => {
    emit('result', result)
    visible.value = false
}

</script>

<template>
    <Teleport to="body">
        <el-dialog
            v-model="visible"
            destroy-on-close
            :width="width"
            :title="title || $t('information')"
            :show-close="false"
            header-class="d-none"
            class="app-dialog"
        >
            <component
                :is="component"
                v-if="component"
                v-bind="componentProps ?? {}"
                @close="close"
                @result="finish"
            />
        </el-dialog>
    </Teleport>
</template>

<style lang="scss">
.app-dialog {
    @media (max-width: 568px) {
        --el-dialog-width: 90%!Important;
    }
}
</style>
